export const termsLink = "Jba";
export default {termsLink};